import { observer } from 'mobx-react';
import { action, toJS } from 'mobx';
import React from 'react';

import TableToolbar from '../../shared/tableToolbar';
import fileReviewStore from './fileReviewStore';

@observer
class FileReviewToolbar extends React.Component {
  handleSubmit = event => {
    event.preventDefault();
    fileReviewStore.refetch({ curPage: 1 }, true);
  };

  handleFilterNextStatus = (_, { value }) => {
    fileReviewStore.refetch({ filterNextStatus: value, curPage: 1 }, true);
  };

  handleFilter = (_, { value }) => {
    fileReviewStore.refetch({ filter: value, curPage: 1 }, true);
  };

  handleReset = () => {
    fileReviewStore.resetStore();
    fileReviewStore.refetch({}, true);
  };

  @action handleRefresh = () => {
    fileReviewStore.data = null;
    fileReviewStore.refetch({}, true);
  };

  render() {
    const {
      keyword,
      fromTo,
      filter,
      loading,
      totalItems,
      filterNextStatus,
      dynamicStatus,
      dynamicNextStatus,
    } = fileReviewStore;

    return (
      <TableToolbar.Container>
        <TableToolbar.Left onSubmit={this.handleSubmit}>
          <TableToolbar.Input value={keyword} onChange={fileReviewStore.handleSearchChange} disabled={loading} />
          <TableToolbar.RangePicker disabled={loading} value={fromTo} onChange={fileReviewStore.handleDateChange} />
          <div className="pd-l-10">
            <TableToolbar.SubmitButton disabled={loading}>SEARCH</TableToolbar.SubmitButton>
          </div>
          <div className="pd-l-10">
            <TableToolbar.HighLightButton color="red" onClick={this.handleReset} disabled={loading}>
              CLEAR
            </TableToolbar.HighLightButton>
          </div>
          <div className="pd-l-10">
            <TableToolbar.HighLightButton className="blue" onClick={this.handleRefresh} disabled={loading}>
              REFRESH
            </TableToolbar.HighLightButton>
          </div>
        </TableToolbar.Left>
        <TableToolbar.Right>
          <span style={{ marginRight: `10px` }} className="nowrap">
            <p>
              <b>Total Cases: {totalItems}</b>
            </p>
          </span>
          <TableToolbar.Filter
            disabled={loading}
            label="Tasks Due"
            style={{ minWidth: '400px' }}
            value={filterNextStatus}
            options={toJS(dynamicNextStatus)}
            onChange={this.handleFilterNextStatus}
          />
          <TableToolbar.Filter
            disabled={loading}
            label="Case Status"
            style={{ minWidth: '400px' }}
            value={filter}
            options={toJS(dynamicStatus)}
            onChange={this.handleFilter}
          />
        </TableToolbar.Right>
      </TableToolbar.Container>
    );
  }
}

export default FileReviewToolbar;
